export default __webpack_public_path__ + "static/media/deleteicon.aea39865.svg";